import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components';
import styles from './BulkActionsBar.module.scss';

interface BulkActionsBarProps {
	selectedCount: number;
	onSelectAll: () => void;
	onDeselectAll: () => void;
	onReset: () => void;
	onUnassign: () => void;
	resetDisabled?: boolean;
	resetDisabledReason?: string;
}

const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
	selectedCount,
	onSelectAll,
	onDeselectAll,
	onReset,
	onUnassign,
	resetDisabled = false,
	resetDisabledReason
}) => {
	const { t } = useTranslation();
	return (
		<div className={styles.bar}>
			<div className={styles.item}>
				<span className={styles.selectedIndicator}>
					<Icon type="check" role="img" />
				</span>
				<span className={styles.selectedCount}>
					{t('learning.courseAssignments.selection.selected', {
						count: selectedCount
					})}
				</span>
			</div>
		
			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--selectAll']}`}
					onClick={onSelectAll}
				>
					{t('learning.courseAssignments.selection.selectAll')}
				</button>
			</div>
		
			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--selectAll']}`}
					onClick={onDeselectAll}
				>
					{t('learning.courseAssignments.selection.deselectAll')}
				</button>
			</div>
		
			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--reset']}`}
					onClick={onReset}
					disabled={resetDisabled}
					title={resetDisabled ? resetDisabledReason : undefined}
				>
					<span className={styles.resetIcon}>
						<Icon type="reset" role="img" />
					</span>
					{t('learning.courseAssignments.selection.reset')}
				</button>
			</div>
		
			<div className={styles.item}>
				<button
					className={`${styles.actionBtn} ${styles['actionBtn--unassign']}`}
					onClick={onUnassign}
				>
					<span className={styles.deleteIcon}>
						<Icon type="redBin" role="img" />
					</span>
					{t('learning.courseAssignments.selection.unassign')}
				</button>
			</div>
		</div>
		
	);
};

export default BulkActionsBar;
